module.exports = __webpack_public_path__ + "static/media/syncui_131.0beb8650.ico";